<template>
  <section class="section" id="products-panel">
    <div class="container">
      <b-loading
        :is-full-page="true"
        :active="isLoadingProducts"
        :can-cancel="false"
      >
        <p v-if="resendingMessage && resendingMessage != ''">
          {{ resendingMessage }}
        </p>
      </b-loading>

      <products-title
        :permissions="permissions"
        :productsQty="pendingProducts.length"
        @get-products="getPending"
      />

      <br /><br />

      <h2
        v-if="!pendingProducts || pendingProducts.length === 0"
        class="subtitle has-text-centered"
      >
        Não existem produtos para revisar no momento :)
      </h2>

      <div v-else>
        <h2 class="subtitle has-text-centered">
          {{ pendingProducts.length }}
          Produtos para revisar
        </h2>

        <products-table
          :products="pendingProducts"
          @update="update"
          @reject="reject"
        />
      </div>
    </div>

    <b-modal :active.sync="showAdjustName">
      <product-modal :product="selectedProduct" @on-update="save" />
    </b-modal>
  </section>
</template>

<script>
import { common } from "../../mixins/common";
import { mask } from "../../mixins/mask";
import { mapGetters } from "vuex";
import productsTitle from "./PendingExternalProductsTitle";
import productsTable from "./PendingExternalProductsTable.vue";
import productModal from "./ProductModal.vue";

export default {
  mixins: [common, mask],

  components: {
    productsTitle,
    productsTable,
    productModal
  },

  data() {
    return {
      isLoadingProducts: false,
      resendingMessage: "",
      pendingProducts: [],
      selectedProduct: null,
      showAdjustName: false
    };
  },

  methods: {
    getPending() {
      this.isLoadingProducts = true;
      this.$store
        .dispatch("getPendingExternalProducts")
        .then(resp => {
          this.pendingProducts = resp.data.payload.imendes.map(p => {
            const motivo =
              p.product.motivodevolucao.toUpperCase() === "DI"
                ? "Descrição Insuficiente"
                : "Código de barras errado";

            return {
              b: p.product.codigo,
              n: p.product.descricao,
              error: motivo,
              original: p
            };
          });
        })
        .catch(() => {
          this.alertError();
        })
        .finally(() => {
          this.isLoadingProducts = false;
        });
    },

    save(data) {
      this.isLoadingProducts = true;

      this.$store
        .dispatch("updateExternalProduct", {
          productName: data.n,
          barCode: data.b,
          imendesReturnedId: this.selectedProduct.original._id
        })
        .then(resp => {
          if (resp.data.result === "ok") {
            // const index = this.pendingProducts.findIndex(
            //   (p) => p.original._id === data.original._id
            // );
            // if (index > -1) {
            //   this.pendingProducts.splice(index, 1);
            // }
          } else {
            this.alertError(resp.data.message);
          }
        })
        .catch(() => {
          this.alertError();
        })
        .finally(() => {
          this.isLoadingProducts = false;
        });
    },

    update(data) {
      this.selectedProduct = data;
      this.showAdjustName = true;
    },

    reject(data) {
      this.isLoadingProducts = true;

      this.$store
        .dispatch("rejectExternalProduct", {
          imendesReturnedId: data.original._id
        })
        .then(resp => {
          if (resp.data.result === "ok") {
            const index = this.pendingProducts.findIndex(
              p => p.original._id === data.original._id
            );

            if (index > -1) {
              this.pendingProducts.splice(index, 1);
            }
          } else {
            this.alertError(resp.data.message);
          }
        })
        .catch(() => {
          this.alertError();
        })
        .finally(() => {
          this.isLoadingProducts = false;
        });
    }
  },

  computed: {
    ...mapGetters(["products", "permissions", "email"])
  },

  mounted() {
    this.getPending();
  }
};
</script>

<style scoped>
#products-panel {
  margin-top: 3rem;
  min-height: 100vh;
  background-color: hsl(0, 0%, 96%);
}
</style>
